import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ScheduledDeliveryPage = lazy(
  () => import('~/features/content-enrichment/pages/scheduled-delivery-page'),
);

/** Step 5 — Delivery page for the Google Ads enrichment funnel. Polls the job
 *  status endpoint until the DELIVERY stage completes, then redirects to
 *  the catalog-operations batch detail. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/enrichments/google/content-enrichment/$batchId/delivery',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ScheduledDeliveryPage />
    </Suspense>
  ),
});
